export const ChildMemoType = {
  MEMO: '센터 메모',
  INFO: '배경정보/주호소',
  GUARDIAN_COUNSELING: '보호자 상담',
} as const;

export const ChildGuardian = {
  CHILD: '아동',
  GUARDIAN: '보호자',
} as const;

export const School = {
  SCHOOL: '취학',
  PRESCHOOL: '미취학',
} as const;

export const LivingTogether = {
  YES: '동거',
  NO: '비동거',
} as const;

export const ChildSearchQueryTarget = {
  GUARDIAN: 'GUARDIAN',
  CHILD: 'CHILD',
  ADDRESS: 'ADDRESS',
} as const;

export const Character = {
  PORONG: '포롱이',
  LEO: '레오',
  RANG: '랑',
  MARU: '마루',
  SOMSOM: '솜솜',
} as const;
